import { Component, OnInit, Input } from '@angular/core';
import { CourseVendorsService } from '../course-vendors.service';

@Component({
    selector: 'app-course-vendors',
    templateUrl: './course-vendors.component.html',
    styleUrls: ['./course-vendors.component.scss']
})
export class CourseVendorsComponent implements OnInit {
    @Input() display;

    constructor(private courseVendorsService: CourseVendorsService) {}

    ngOnInit(): void {
        this.get();
    }

    get(): void {
        this.courseVendorsService.get();
    }

    collapse(): void {
        if (this.isEditable) return;
        this.display = !this.display;
    }

    reload(): void {
        if (this.isEditable) return;
        this.get();
    }

    add(): void {
        if (this.isEditable) return;
        this.display = true;
        this.courseVendorsService.isAdd = true;
        this.courseVendorsService.isEditable = true;
    }

    get isAdd() {
        return this.courseVendorsService.isAdd;
    }

    get isEditable() {
        return this.courseVendorsService.isEditable;
    }

    get courseVendors() {
        return this.courseVendorsService.courseVendors;
    }

    get isLoading() {
        return this.courseVendorsService.isLoading;
    }

    get errorMessage() {
        return this.courseVendorsService.errorMessage;
    }

}
